import moment from 'moment';
import Firebase from '../../../lib/Firebase';
import Firestore from '../../../lib/Firestore';

export default {
  all(city) {
  //const cityRef = Firebase.firestore().collection('hotels').doc(city.docId);
    return Firebase.firestore()
      .collection('seasons')
      .where("hotel", "==", city.docId)
      .get()
      .then(docs => {
        return Firestore.getCollectionData(docs);
      });
  },

  manage(city, docId, label, startDate, endDate,) {
    const seasonObj = {
      label: label,
      startDate: moment(startDate).valueOf(),
      endDate:   moment(endDate).valueOf(),
      hotel : city.docId
    };
    const promise = docId
      ? Firebase.firestore()
         .collection('seasons')
         .doc(docId)
         .update(seasonObj)
      : Firebase.firestore()
          .collection('seasons')
          .add(seasonObj);
    return promise;
  },

  deleteOption(city) {
    return Firebase.firestore()
      .collection('seasons').doc(docId)
      .delete();
  }
};



// WEBPACK FOOTER //
// ./src/pages/hotel/Seasons/service.js